import React from "react";

/**
 * Skeleton placeholder for a product card while Shopify data loads.
 * Mirrors the actual ProductCard footprint (aspect-[4/5] image + 2 text lines).
 */
const ProductCardSkeleton = () => (
  <div className="block" aria-hidden="true">
    <div
      className="aspect-[4/5] rounded-[18px] mb-4 bg-pearl relative overflow-hidden"
      style={{
        background:
          "linear-gradient(100deg, #F9F2EC 0%, #FBEAF0 50%, #F9F2EC 100%)",
        backgroundSize: "200% 100%",
        animation: "ggSkelShimmer 1.6s linear infinite",
      }}
    />
    <div
      className="h-3 w-2/3 rounded-full mb-2"
      style={{
        background:
          "linear-gradient(100deg, #F9F2EC, #FBEAF0, #F9F2EC)",
        backgroundSize: "200% 100%",
        animation: "ggSkelShimmer 1.6s linear infinite",
      }}
    />
    <div
      className="h-3 w-1/3 rounded-full"
      style={{
        background:
          "linear-gradient(100deg, #F9F2EC, #FBEAF0, #F9F2EC)",
        backgroundSize: "200% 100%",
        animation: "ggSkelShimmer 1.6s linear infinite",
      }}
    />
    <style>{`
      @keyframes ggSkelShimmer {
        0%   { background-position: -200% 0; }
        100% { background-position: 200% 0; }
      }
    `}</style>
  </div>
);

export default ProductCardSkeleton;
